module.exports = __webpack_public_path__ + "img/mechanics-dcfecorporation.f216f80a.png";